import * as $ from "jquery";
import "waypoints/lib/jquery.waypoints.js";

class ProgressBar {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  percentContainer: JQuery<HTMLElement>;
  progressBar?: HTMLElement;
  progressBarLength: any;
  percent: number;
  percentToAnimate: number;
  hasAnimationRun: boolean;
  animationSpeed: number;
  uiPercentsArray: any[];

  constructor (componentRoot: HTMLElement, params) {
    this.componentRoot = $(componentRoot);
    this.params = { ...params };

    this.percentContainer = $('.component--progress-bar__percent', this.componentRoot);
    this.progressBar = document.getElementById(this.params.progressBarId) as HTMLElement;
    this.progressBarLength = this.progressBar.getTotalLength();
    this.percent = Number(this.params.percent);
    this.percentToAnimate = this.progressBarLength * ((100 - this.percent) / 100);
    this.progressBar.style.strokeDashoffset = `${this.progressBarLength}px`;
    this.progressBar.style.strokeDasharray = `${this.progressBarLength}px`;
    this.hasAnimationRun = false;
    this.animationSpeed = 1000; // this is tied to CSS value
    this.uiPercentsArray = this.makePercentsArray(this.percent);
    this.init();
  }

  init () {
    this.updatePercent(0);
    this.bottomInView();
  }

  iteratePercent (count: number) {
    setTimeout(() => {
      this.updatePercent(count);
    }, (this.animationSpeed / this.percent) * count);
  }

  updatePercent (percent: number) {
    this.percentContainer.text(`${percent}%`);
  }

  makePercentsArray () {
    let percentArray = [];
    for (var count = 0; count <= this.percent; count += 1) {
      percentArray.push(count);
    }
    if (this.percent % 1 !== 0) {
      percentArray.push(this.percent);
    }
    return percentArray;
  }

  bottomInView () {
    var self = this;
    new Waypoint({
      element: self.componentRoot as any,
      handler: function(direction) {
        if (!self.hasAnimationRun) {
          if (direction === 'down') {
            setTimeout(() => {
              self.progressBar.classList.add('active');
              self.progressBar.style.strokeDashoffset = `${self.percentToAnimate}px`;
              self.uiPercentsArray.forEach(percent => {
                self.iteratePercent(percent);
              });
            }, parseInt(self.params.delay));
          }
          self.hasAnimationRun = true;
        }

      },
      offset: 'bottom-in-view'
    });
  }
}

export default ProgressBar;
